type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function CashIcon({ width = 12, height = 12, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            className={className}
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 2C0.447716 2 0 2.44771 0 3V6.875C0 7.4273 0.447716 7.875 1 7.875H8.875C9.4273 7.875 9.875 7.4273 9.875 6.875V3C9.875 2.44771 9.4273 2 8.875 2H1ZM4.9375 6.1875C5.62785 6.1875 6.1875 5.62785 6.1875 4.9375C6.1875 4.24714 5.62785 3.6875 4.9375 3.6875C4.24715 3.6875 3.6875 4.24714 3.6875 4.9375C3.6875 5.62785 4.24715 6.1875 4.9375 6.1875Z"
                fill="currentColor"
            />
            <path
                d="M11.375 3.875C11.0298 3.875 10.75 4.15482 10.75 4.5V7.875C10.75 8.35825 10.3582 8.75 9.875 8.75H2C1.65482 8.75 1.375 9.0298 1.375 9.375C1.375 9.7202 1.65482 10 2 10H9.875C11.0486 10 12 9.0486 12 7.875V4.5C12 4.15482 11.7202 3.875 11.375 3.875Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default CashIcon;
